import React from "react";
import ReactSpeedometer from "react-d3-speedometer";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import CircularProgress from "@mui/material/CircularProgress";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControl from "@mui/material/FormControl";
import { colorPalettes } from "../../mock_data/data";
import { useSearchParams } from "react-router-dom";

const SpeedoMeter = ({ data, fetching, colorPalette, speedometerType }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [showLabels, setShowLabels] = React.useState(true);
  const [showCurrentValue, setShowCurrentValue] = React.useState(true);
  const [searchParams] = useSearchParams();
  console.log("showCurrentValue", showCurrentValue);
  const valueToShow = () => {
    if (!data) return 0;
    const speedometerType = searchParams.get("type");
    if (speedometerType === "1") {
      return data.Accuracy ? data.Accuracy : 0;
    } else if (speedometerType === "2") {
      return data.DiffScore ? data.DiffScore : 0;
    } else if (speedometerType === "3") {
      return data.Accuracy ? data.Accuracy : 0;
    }
    return data.Accuracy ? data.Accuracy : 0;
  };

  const onChangeShowLabels = () => {
    setIsLoading(true);
    setShowLabels(!showLabels);
    setTimeout(() => setIsLoading(false), 400);
  };

  const onChangeShowCurrentValue = () => {
    setIsLoading(true);
    setShowCurrentValue(!showCurrentValue);
    setTimeout(() => setIsLoading(false), 400);
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {isLoading || fetching ? (
          <Box
            sx={{
              display: "flex",
              width: "400px",
              height: "300px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div
            style={
              speedometerType == "2"
                ? {
                    width: "400px",
                    height: "300px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                  }
                : {
                    width: "400px",
                    height: "300px",
                  }
            }
          >
            <ReactSpeedometer
              paddingHorizontal={10}
              paddingVertical={10}
              maxSegmentLabels={showLabels ? 15 : 0}
              fluidWidth={true}
              needleHeightRatio={0.7}
              value={valueToShow().toFixed(2)}
              maxValue={100}
              customSegmentStops={[
                0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
                80, 85, 90, 95, 100,
              ]}
              segmentColors={colorPalette}
              currentValueText={"Current Value: #{value}"}
              currentValuePlaceholderStyle={"#{value}"}
              ringWidth={47}
              needleTransitionDuration={2000}
              needleColor={"#00bbf0"}
              textColor={"#000"}
              valueTextFontSize={showCurrentValue ? "16px" : "0px"}
              labelFontSize={showLabels ? "16px" : "0px"}
            />
            {speedometerType == "2" ? (
              <ReactSpeedometer
                paddingHorizontal={10}
                paddingVertical={10}
                currentValueText={"Current Value: #{value}"}
                currentValuePlaceholderStyle={"#{value}"}
                maxSegmentLabels={showLabels ? 15 : 0}
                fluidWidth={true}
                needleHeightRatio={0.7}
                value={data && data.Accuracy ? data.Accuracy.toFixed(2) : 0}
                maxValue={100}
                customSegmentStops={[
                  0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
                  80, 85, 90, 95, 100,
                ]}
                segmentColors={colorPalettes[0].colors}
                currentValueText={"Current Value: #{value}"}
                currentValuePlaceholderStyle={"#{value}"}
                ringWidth={47}
                needleTransitionDuration={2000}
                needleColor={"#00bbf0"}
                textColor={"#000"}
                valueTextFontSize={showCurrentValue ? "16px" : "0px"}
                labelFontSize={showLabels ? "16px" : "0px"}
              />
            ) : null}
          </div>
        )}
      </div>
      <div style={{ display: fetching ? "none" : "block" }}>
        <h3>Speedometer Customization</h3>
        <FormControl component="fieldset">
          {/* <FormLabel component="legend">Speedometer Options</FormLabel> */}
          <FormGroup aria-label="position" row>
            <FormControlLabel
              value="showLabels"
              control={
                <Switch
                  checked={showLabels}
                  color="primary"
                  onChange={onChangeShowLabels}
                />
              }
              label="Labels"
              labelPlacement="start"
            />
            <FormControlLabel
              value="showCurrentValue"
              control={
                <Switch
                  checked={showCurrentValue}
                  onChange={onChangeShowCurrentValue}
                  color="primary"
                />
              }
              label="Current value"
              labelPlacement="start"
            />
          </FormGroup>
        </FormControl>
      </div>
    </React.Fragment>
  );
};
export default SpeedoMeter;
